<template>
  <div id="app" :class="is_dark?'dark-content':''">
    <router-view ></router-view>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'App',
  data (){
    return {
      is_dark: false
    }
  },
  created() {
      this.is_dark = this.$route.query.dark;
      if(this.is_dark){
        $('html').css({'background-color': '#242424'})
      }
  }
}
</script>

<style lang="scss">
.dark-content{
  .sex-btn.active,
  .switch-normal, .switch-human{
    background-color: #AC4B38!important;
    color: #ffffff!important;
  }
  .sex-btn,
  .choice_select,
  .section1 h2, .section2 h2{
    border-color: #AC4B38!important;
  }
  .sex-btn,
  .recommend-title,
  .again-btn,
  .section1 h2, .section2 h2,
  .btns-content button{
    color: #AC4B38!important;
  }
 .page-loading .loading-content .title,
 .recommend-list li .box,
 .disease-select li .text,
 .disease-sort-ul li.active,
 .question-title,
 .choice_select,
 .sub_title,
 .mc-anli-p1{
    color: #ffffff!important;
  }
  .disease-sort-ul li,
  .p-content{
    color: #cccccc!important;
  }
  .ice_bg,
  .page-loading,
  .human-main,
  .home-content,
  .disease-sort-ul li.active,
  .question-content,
  .again-btn,
  .btns-content button{
    background-color: #333333!important;
  }
  .disease-sort-ul,
  .disease-sort-ul li,
  .icon-composition,
  .br-t-l, .br-t-r, .br-b-l, .br-b-r{
    background-color: #262626!important;
  }
  .disease-select li,
  .disease-sort-ul li,
  .recommend-list li .box,
  .section-bor-bom{
      border-color: #4a4a4a!important;
  }
  .disease-sort-ul li.active{
    border-left-color: #AC4B38!important;
  }
  .disease-sort-ul li{
    border-left-color: #262626!important;
  }
  .disease-content{
    border-color: #242424!important;
  }
  .btns-content .left{
    border: none;
  }
}
</style>

